<template>
  <div
    class="bg-white bg-opacity-90 text-gray-700 fixed bottom-0 inset-x-0 shadow-xs"
    v-show="!isSet('cookie_consent')"
  >
    <div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
      <div class="flex flex-wrap items-center">
        <div class="flex-auto lg:pr-6">
          <slot>
            <p>
              We use cookies to help provide you with the best possible online
              experience.<br />
              By using this site, you agree that we may store and access cookies
              on your device.
              <a href="/cookies">Find out about our cookies.</a>
            </p>
          </slot>
        </div>
        <div class="flex-shrink">
          <div class="inline-block rounded-md shadow">
            <button
              type="button"
              class="btn btn-sm btn-primary-gray"
              @click.prevent="set('cookie_consent')"
            >
              Accept all cookies
            </button>
          </div>
          <div class="inline-block rounded-md shadow">
            <button
              type="button"
              class="btn btn-sm btn-primary-gray"
              @click.prevent="toggle"
            >
              <span v-if="!show">Show options</span>
              <span v-else>Hide options</span>
            </button>
          </div>
        </div>
      </div>
      <CookieSetup
        v-if="show"
        class="mt-6 pt-6 border-t border-solid border-gray-300"
      />
    </div>
  </div>
</template>
<script>
import BaseCookie from './BaseCookie';
import CookieSetup from './CookieSetup';
export default {
  name: 'CookieConsent',
  mixins: [BaseCookie],
  components: { CookieSetup },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
};
</script>
